import { useMemo } from 'react';
import { ballColor } from '@photo-merge/shared';
import { pickStockBalls, stockUrl } from '../game/art';

interface StockFaceProps {
  size?: number;
  /** Fixes which face is shown; omit for a random one per mount. */
  seed?: number;
  className?: string;
}

/**
 * A single stock face, ringed like a real ball. Used wherever the app wants to hint at
 * what the game is made of — a random face says it better than an icon can.
 */
export function StockFace({ size = 34, seed, className }: StockFaceProps) {
  const name = useMemo(() => pickStockBalls(1)[0]!, [seed]);
  // Ranks 1-11 so the ring colour varies with the face rather than always matching.
  const rank = useMemo(() => 1 + Math.floor(Math.random() * 11), [seed]);

  return (
    <span
      className={className}
      aria-hidden="true"
      style={{
        display: 'block',
        width: size,
        height: size,
        borderRadius: '50%',
        border: `${Math.max(2, size * 0.11)}px solid ${ballColor(rank, 11)}`,
        backgroundImage: `url(${stockUrl(name)})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxSizing: 'border-box',
      }}
    />
  );
}
